import { ENV_NAME } from './env';
import { Region } from './region';
import type { DomainConfig } from './types';

const LOCALHOST_PORT = process.env.NEXT_PUBLIC_LOCALHOST_PORT || '8080';

export const LOCALHOST_ENDPOINT = `http://localhost:${LOCALHOST_PORT}`;
export const LOCALHOST_WS_ENDPOINT = `ws://localhost:${LOCALHOST_PORT}`;

export const DEV_ENDPOINT = 'https://resident.api.heidihealth.com';
export const DEV_WS_ENDPOINT = 'wss://resident.api.heidihealth.com';

export const PREVIEW_HOSTNAME = 'ml-scribe.dev.aue1.aws.ext.heidi.ai';
export const ML_SCRIBE_PREVIEW_HOSTNAMES: Partial<Record<Region, string>> = {
  [Region.AU]: PREVIEW_HOSTNAME,
  [Region.US]: 'ml-scribe.dev.use1.aws.ext.heidi.ai',
};
export const TRANSCRIPTION_PREVIEW_HOSTNAME = 'transcription.dev.aue1.aws.ext.heidi.ai';

export const STAGING_ENDPOINT = 'https://registrar.api.heidihealth.com';
export const STAGING_WS_ENDPOINT = 'wss://registrar.api.heidihealth.com';

export const AZURE_DEV_ENDPOINT = 'https://resident-auaz.api.heidihealth.com';
export const AZURE_DEV_WS_ENDPOINT = 'wss://resident-auaz.api.heidihealth.com';

export const scribeDomains: DomainConfig = {
  [Region.UK]: {
    [ENV_NAME.PROD]: 'https://uk.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_ENDPOINT,
  },
  [Region.CA]: {
    [ENV_NAME.PROD]: 'https://ca.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_ENDPOINT,
  },
  [Region.US]: {
    [ENV_NAME.PROD]: 'https://us.api.heidihealth.com',
    [ENV_NAME.DEV]: 'https://resident.us.api.heidihealth.com',
    [ENV_NAME.STAGING]: 'https://registrar.us.api.heidihealth.com',
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_ENDPOINT,
  },
  [Region.EU]: {
    [ENV_NAME.PROD]: 'https://eu.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_ENDPOINT,
  },
  [Region.CH]: {
    [ENV_NAME.PROD]: 'https://ch.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_ENDPOINT,
  },
  [Region.AU]: {
    [ENV_NAME.PROD]: 'https://au.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_ENDPOINT,
  },
  [Region.AU_AZ1]: {
    [ENV_NAME.PROD]: 'https://au-az1.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_ENDPOINT,
    [ENV_NAME.STAGING]: 'https://au-az1.api.staging.heidihealth.com',
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_ENDPOINT,
  },
  [Region.JP_AZ1]: {
    [ENV_NAME.PROD]: 'https://jp-az1.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_ENDPOINT,
  },
  [Region.QAT_AZ1]: {
    [ENV_NAME.PROD]: 'https://qat-az1.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_ENDPOINT,
  },
  [Region.UAE_AZ1]: {
    [ENV_NAME.PROD]: 'https://uae-az1.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_ENDPOINT,
  },
  [Region.US_AZ1]: {
    [ENV_NAME.PROD]: 'https://us-az1.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_ENDPOINT,
  },
  [Region.SE_AZ1]: {
    [ENV_NAME.PROD]: 'https://se-az1.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_ENDPOINT,
  },
};

export const scribeWebsocketDomains: DomainConfig = {
  [Region.UK]: {
    [ENV_NAME.PROD]: 'wss://uk.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_WS_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_WS_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_WS_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_WS_ENDPOINT,
  },
  [Region.CA]: {
    [ENV_NAME.PROD]: 'wss://ca.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_WS_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_WS_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_WS_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_WS_ENDPOINT,
  },
  [Region.US]: {
    [ENV_NAME.PROD]: 'wss://us.api.heidihealth.com',
    [ENV_NAME.DEV]: 'wss://resident.us.api.heidihealth.com',
    [ENV_NAME.STAGING]: 'wss://registrar.us.api.heidihealth.com',
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_WS_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_WS_ENDPOINT,
  },
  [Region.EU]: {
    [ENV_NAME.PROD]: 'wss://eu.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_WS_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_WS_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_WS_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_WS_ENDPOINT,
  },
  [Region.CH]: {
    [ENV_NAME.PROD]: 'wss://ch.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_WS_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_WS_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_WS_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_WS_ENDPOINT,
  },
  [Region.AU]: {
    [ENV_NAME.PROD]: 'wss://au.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_WS_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_WS_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_WS_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_WS_ENDPOINT,
  },
  [Region.AU_AZ1]: {
    [ENV_NAME.PROD]: 'wss://au-az1.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_WS_ENDPOINT,
    [ENV_NAME.STAGING]: 'wss://au-az1.api.staging.heidihealth.com',
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_WS_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_WS_ENDPOINT,
  },
  [Region.JP_AZ1]: {
    [ENV_NAME.PROD]: 'wss://jp-az1.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_WS_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_WS_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_WS_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_WS_ENDPOINT,
  },
  [Region.QAT_AZ1]: {
    [ENV_NAME.PROD]: 'wss://qat-az1.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_WS_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_WS_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_WS_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_WS_ENDPOINT,
  },
  [Region.UAE_AZ1]: {
    [ENV_NAME.PROD]: 'wss://uae-az1.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_WS_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_WS_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_WS_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_WS_ENDPOINT,
  },
  [Region.US_AZ1]: {
    [ENV_NAME.PROD]: 'wss://us-az1.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_WS_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_WS_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_WS_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_WS_ENDPOINT,
  },
  [Region.SE_AZ1]: {
    [ENV_NAME.PROD]: 'wss://se-az1.api.heidihealth.com',
    [ENV_NAME.DEV]: DEV_WS_ENDPOINT,
    [ENV_NAME.STAGING]: STAGING_WS_ENDPOINT,
    [ENV_NAME.AZURE_DEV]: AZURE_DEV_WS_ENDPOINT,
    [ENV_NAME.LOCALHOST]: LOCALHOST_WS_ENDPOINT,
  },
};
